import React from 'react';
import I18n from 'i18n-js';
import { string } from 'prop-types';
import sizeConfig from '../helpers/sizeConfig';

const SizeLabel = ({ size = '' }) => (
  <span className="tickets-index-page__size-label">
    {sizeConfig[size].icon}
    {I18n.t(`tickets.sizes.${size}`)}
  </span>
);

SizeLabel.propTypes = {
  size: string,
};

export default SizeLabel;
